
function coll_top_slider(){
  var $flkty3 = new Flickity( '.category-list-wrapp', {
  cellAlign: 'center',
    contain: true,
  pageDots: false,
  accessibility: false,
  autoPlay: false 
});

   if($('.category-list-wrapp .category__item.select_this').length >= 1){
      console.log($('.category-list-wrapp .category__item.select_this').length >= 1);
      $flkty3.select($('.category-list-wrapp .category__item.select_this').attr('data-loop_index'));
  }
}

$(document).ready(function() {
  coll_top_slider();
  
  $(".article__grid-image").on('click', function() {
     $(this).parents(".grid__item").find(".custom-model-main").addClass('model-open');
  });

   $(".product-video-link").on('click', function() {
     $(this).parents(".grid__item").find(".custom-model-main-video").addClass('model-open');
  });

     $(".product-image-link").on('click', function() {
     $(this).parents(".grid__item").find(".custom-model-main-img").addClass('model-open');
  });

  
  $(".close-btn, .bg-overlay").click(function(){
    $(this).parents(".custom-model-main").removeClass('model-open');
    $(this).parents(".custom-model-main").find("video").trigger('pause');
  });

var $flkty2 = new Flickity( '.com-img-around', { 
  wrapAround: true,
  pageDots: false,
  initialIndex: 1,
  accessibility: false,
  autoPlay: false 
});
  // RECOMANDECTION SLIDER

 if ($(window).width() > 769) {

  var $flkty5 = new Flickity( '.template-article .blog-post-main .grid', {
    groupCells: 'true', 
    cellAlign: 'left',
    adaptiveHeight: false,
    pageDots: false,
    prevNextButtons: true,
    contain: true  
  }); 
   
  var is_recomendection;
      function recomandection_check() {
       is_recomendection = setInterval(function () {
       slider_applay()
       }, 300);
      }
      recomandection_check();
      function slider_applay() {
      if($('.product-recommendations-placeholder .grid .grid__item').length >= 3) {
       clearInterval(is_recomendection); 
       
            var $flkty4 = new Flickity( '.product-recommendations-placeholder .grid', {
            contain: true,
           wrapAround: false,
            pageDots: false,
            initialIndex: 1,
            accessibility: false,
            autoPlay: false
          });
     addtocart_custom();
      }

}
          function recentaly_view() {
                is_recentley_view = setInterval(function () {
                  recentley_slider()
                }, 300);
            }
            recentaly_view();
            function recentley_slider() {
              if($('.recently-around .grid .grid__item').length >= 3) {
              clearInterval(is_recentley_view); 
              
                    var $flkty4 = new Flickity( '.recently-around .grid', {
                      contain: true,
                      wrapAround: false,
                      pageDots: false,
                      initialIndex: 1,
                      accessibility: false,
                      autoPlay: false
                  });
              
              } 
          } 
     
 }
  
// CUSTOM SORL TOGGLE

  $(document).on("click", "body", function(t) {
    if ($(t.target).is("#toggle-sort")){
       $('.cstm-sort>ul').slideToggle('500','linear');
    } else {
      $('.cstm-sort>ul').hide();
      // if($(t.target).is("li.sort_options_cust")){
      //   window.location.replace($(this).attr('data-short-val'));       
      // } else {
      //   $('.collection-grid__wrapper .collection-filter__sort-container .cstm-sort>ul').hide();
      // }
    }
  });
  
  
  // QUICK ADD TO CART CODE START

function addtocart_custom(){
var status = {
      loading: false
    };
  
     $(".grid__item .grid-product__content .product-single__form.quick_add_form").on("submit",function(evt){
         evt.preventDefault();
            // Loading indicator on add to cart button

       if (status.loading) {
          return;
        }
       status.loading = true;
       
         $(this).find('button.add-to-cart').addClass('btn--loading');
         
            var data = theme.utils.serialize(this);
           const $_this = $(this)
            fetch(theme.routes.cartAdd, {
              method: 'POST',
              body: data,
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => response.json())
            .then(function(data) {
              if (data.status === 422) {
                error(data,$_this);
              } else {
                var product = data;
                success(product,$_this);
              }
            })
    
         function success(product,form){
           console.log(form);
           $('.product-single__form.quick_add_form .error')
           status.loading = false;
            form.find('button.add-to-cart').removeClass('btn--loading');
           // $('button.add-to-cart').removeClass('btn--loading');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: product,
                addToCartBtn: this.addToCart
              }
            }));
         }
    
          function error(error,form) {
            status.loading = false;
             // $('button.add-to-cart').removeClass('btn--loading');
            form.find('button.add-to-cart').removeClass('btn--loading');
             console.log(error);
          }     
     });
}

  addtocart_custom();
 // QUICK ADD TO CART CODE END

 // HOME PAGE VIDEO PLAY START
    $('#play').click(function(){
       $(this).parent('.video_banner-inner').hide();
       $(this).closest('.video-wrapper').find('video')[0].play();
    });
 // HOME PAGE VIDEO PLAY END

// CART ITEMS REMOVE START 
$(document).on('click', 'a.cart-items-remove', function(event) {
  event.preventDefault();
console.log($(this).attr('data-id'));
        remove_cart_items($(this).attr('data-id'));
 });


      $(document).on('click', 'ul.blog_cust_filter li', function(event) {
          event.preventDefault();
          location.href =$(this).attr('data-url-value');
      });
   
  
  
    function remove_cart_items(id) {
   var headers = new Headers({ 'Content-Type': 'application/json' });
       let product = {};
          product[id] = 0,
    console.log(product);
      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ updates: product})
      };
      fetch('/cart/update.js', request)
      .then(function() {
      document.dispatchEvent(new CustomEvent('cart:build'));
      });
      }    
// CART ITEMS REMOVE END
});

